import {SimplePresentation, SimplePresentationRunnerController} from "../../core/presentation/SimplePresentationRunner";
import {HOTB} from "../HOTB";
import {gsap} from "gsap";
import {HOTBGameData, IBigWinLevel} from "../server/HOTBData";
import {GameUtils} from "../utils/GameUtils";
import {GameSounds} from "../sound/GameSounds";
import {ExtendedGameModel} from "../server/ExtendedGameModel";

export class BigWinPresentation implements SimplePresentation {
    shouldRun(): boolean {
        const gameModel: ExtendedGameModel = HOTB.model,
            gameData: HOTBGameData = gameModel.gameData;

        // #268 updating winning amount in the keypad if below stake
        if (gameModel.winRatio >= 15 && GameUtils.isSingleWinBelowStake()) {
            HOTB.keypadPlugin.setWin(gameData.accumulatedRoundWin, true, GameUtils.isWinBelowStake());
        }

        return GameUtils.isBigWin();
    }

    start(controller: SimplePresentationRunnerController): void {
        const gameModel: ExtendedGameModel = HOTB.model,
            gameData: HOTBGameData = gameModel.gameData,
            levels: IBigWinLevel[] = gameModel.getBigWinLevels(gameModel.winRatio),
            tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onStart: (): void => {
                    HOTB.soundPlayer.fadeMusic(0, 0.01);
                    HOTB.preBigWinView.resetAnim();
                },
                onComplete: (): void => {
                    controller.finish();
                }
            });

        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = bigWinLevel.from * gameData.playedBetValue,
                to: number = bigWinLevel.to * gameData.playedBetValue;

            tl.add((): void => {
                controller.setSkipCallback((): void => {
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            });

            tl.add(HOTB.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id));

            tl.addLabel(bigWinLevel.type + "_end");
        }

        tl.add((): void => {
            controller.setSkipCallback();
        });

        tl.add((): void => {
            HOTB.soundPlayer.stopSound(GameSounds.BIG_WIN_LEVELS[(levels.length) - 1]);
            HOTB.soundPlayer.playSound(GameSounds.BIG_WIN_END);
        });

        tl.to(this, {
            duration: 0.2
        });

        tl.add([
            HOTB.bigWinView.hide(0.5),
            (): void => {
                HOTB.soundPlayer.fadeMusic(1, 0.01);
            }
        ]);

        tl.add((): void => {
            if(!(HOTB.model.data.freespinsLeft === 0 && HOTB.model.gameData.numberOfFreespinsPlayed > 0)) {
                HOTB.keypadPlugin.setWin(gameData.accumulatedRoundWin, true, GameUtils.isWinBelowStake());
            }
        });
    }
}